import { Route } from "wouter";

// Shared pages accessible by multiple roles
import Employees from "@/pages/broker/Employees";
import EmployeeDetail from "@/pages/broker/EmployeeDetail";
import PlanDetail from "@/pages/broker/PlanDetail";
import Enrollments from "@/pages/broker/Enrollments";
import Premiums from "@/pages/broker/Premiums";
import Calendar from "@/pages/broker/Calendar";
import NotFound from "@/pages/broker/not-found";
import EmailInbox from "@/pages/broker/EmailInbox";
import EmailDetail from "@/pages/broker/EmailDetail";

export function SharedRoutes() {
  return (
    <>
      <Route path="/emails" component={EmailInbox} />
      <Route path="/emails/:id" component={EmailDetail} />
      <Route path="/clients/:clientId/employees" component={Employees} />
      <Route
        path="/clients/:clientId/employees/:employeeId"
        component={EmployeeDetail}
      />
      <Route path="/employee/:employeeId" component={EmployeeDetail} />
      <Route path="/plans/:id" component={PlanDetail} />
      <Route path="/enrollments" component={Enrollments} />
      <Route path="/premiums" component={Premiums} />
      <Route path="/calendar" component={Calendar} />
    </>
  );
}

export { NotFound };
